
import theme from "../../../styles/theme";
import React, { useState } from "react";

const TabsNavHorizontal = ({ labels, activeIndex, onChange }) => {
  const [hovered, setHovered] = useState(null);

  const bgHover    = theme.colors.background.hover;
  const textIdle   = theme.colors.text.corelia;
  const gap        = theme.spacing.md;
  const padY       = theme.spacing.sm;
  const padX       = theme.spacing.lg;
  const radius     = theme.borders.radius.md;
  const font       = theme.fonts.corelia;
  const fwMedium   = theme.fontWeights.normal;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap,
        justifyContent: "center",
        alignItems: "center",
        padding: padY,
      }}
    >
      {labels.map((tab, index) => {
        const data = typeof tab === "string" ? { label: tab } : tab;
        const isHover  = hovered === index;

        return (
          <div
            key={index}
            onClick={() => onChange(index)}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(null)}
            style={{
              cursor: "pointer",
              padding: `${padY}px ${padX}px`,
              borderRadius: radius,
              backgroundColor: isHover ? bgHover : "transparent",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap,
              transition: "background-color 0.2s ease, color 0.2s ease, transform 0.2s ease",
              userSelect: "none",
            }}
          >
            {data.icon && (
              <img
                src={data.icon}
                alt={`${data.label}-icon`}
                style={{
                  width: 20,
                  height: 20,
                  filter: "none",
                  transform: isHover ? "scale(1.15)" : "scale(1)",
                  transition: "transform 0.2s ease",
                }}
              />
            )}
            <span
              style={{
                fontFamily: font,
                fontWeight: fwMedium,
                color: data.colorIdle || textIdle,
                whiteSpace: "nowrap",
              }}
            >
              {data.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default TabsNavHorizontal;
